import { useState } from 'react';

export default function SearchBox(props) {
  const [search, setSearch] = useState('');

  function onBoxChange(value) {
    setSearch(value);
    if (value.length > 1) {
      props.searchText(value);
    } else if (value.length === 0) {
      props.searchText(value);
    }
  }

  return (
    <div style={styles.inputContainer}>
      <input
        type="text"
        name="search"
        value={search}
        onChange={(e) => onBoxChange(e.target.value)}
        style={styles.input}
        autoFocus={true}
        autoComplete={'off'}
      />
    </div>
  );
}

const styles = {
  inputContainer: {
    margin: '0px auto',
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  input: {
    fontSize: 20,
    fontWeight: 'normal',
    border: 'none',
    borderColor: 'transparent',
    marginTop: 0,
    borderRadius: '5px',
    height: 40,
    backgroundColor: '#dddddd',
    padding: 0,
    paddingLeft: 10,
    color: '#3A3A3C',
    width: '100%',
    textAlign: 'left'
  }
}